import axios from 'axios'
import { apiConfig } from '@/types/api'
import { ApiError } from '@/types/api'
import {
  logOnRequestSuccess,
  logOnRequestError,
  logOnResponseSuccess,
  logOnResponseError,
} from '@/utils/log'

const authClient = axios.create(apiConfig)
authClient.interceptors.response.use(
  (response) => {
    const { data } = response
    logOnResponseSuccess(response)
    // 1. 业务成功（code=200）：返回业务数据部分
    if (data.code === '200') {
      return data.data
    }
    throw new ApiError(data.code, data.msg)
  },
  (error) => {
    logOnResponseError(error)
    throw error
  },
)

authClient.interceptors.request.use(logOnRequestSuccess, logOnRequestError)
export async function login(
  code: string,
): Promise<{ access_token: string; refresh_token: string }> {
  return await authClient.post('/user/login?code=' + code, {})
}
export default authClient
